import './lib/sentry';
import React from 'react';
import ReactDOMClient from 'react-dom/client';
import { App } from '~/components/root/App';
import { captureReferralFromUrl } from '~/lib/referralCapture';
import { captureAdAttributionFromUrl } from '~/lib/adAttribution';
import { captureActivitySourceFromUrl } from '~/lib/activityTrack';
import { captureViewAsFromUrl } from '~/lib/viewAs';
import { captureSignupIntent } from '~/lib/oidc';
import './index.css';

// ANTES de montar React, y a propósito. Quien llega por el enlace de un
// referidor cae en una ruta protegida: `AuthGuard` lo manda al OIDC y el `?ref`
// no vuelve del viaje. Esto es lo único que corre con la URL original todavía
// en la barra. Ver `lib/referralCapture.ts`.
captureReferralFromUrl();
// El clic del anuncio (ttclid, _ttp, utm_*), por la misma razón. Ver
// `lib/adAttribution.ts`.
captureAdAttributionFromUrl();
// De qué aviso (`?n=`) o anuncio (utm_*) llegó, para la actividad diaria, por la
// misma razón. Ver `lib/activityTrack.ts`.
captureActivitySourceFromUrl();
// «Ver como» del admin, por la misma razón: el `?ver_como=` no sobrevive el
// rodeo por el OIDC si la pestaña nueva todavía no tiene sesión.
captureViewAsFromUrl();
// «Crear mi perfil gratis» (`?signup=1`), por la misma razón: abre «Crear cuenta»
// en auth.tbit.app. Ver `lib/oidc.ts`.
captureSignupIntent();

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOMClient.createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
